<div class="key">
    <label>{{ label }}<span class="required" *ngIf="required"></span></label>
    
    <ng-container *ngIf="fieldDefinitionType">
        <field-definition [fieldDefinitionType]="fieldDefinitionType" [iconOnly]="true" [popperOptions]="popperOptions"></field-definition>
    </ng-container>
</div>
